import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { getEnv } from './shared/config/env.js';
import { useAuthStore } from './features/auth/model/auth.store.js';
import { Providers } from './app/providers.js';
import './styles.css';

const bootstrap = async (): Promise<void> => {
  // Sozlamalar noto'g'ri bo'lsa — ilova chizilmasidan oldin aniq xato beradi.
  getEnv();

  // Shart `import.meta.env` ustidan yozilgan: Vite uni qurilish paytida
  // qiymatga almashtiradi, shuning uchun mock kodi production bundle iga
  // umuman tushmaydi. Mantiq `readEnv` bilan bir xil.
  if (import.meta.env.VITE_MOCK === 'true') {
    const { startMockWorker } = await import('./mocks/browser.js');
    await startMockWorker();
  }

  // Saqlangan sessiya chizishdan OLDIN tiklanadi — aks holda birinchi kadrda
  // token yo'qdek ko'rinib, `RequireAuth` bekorga `/login` ga otib yuboradi.
  useAuthStore.getState().hydrate();

  const container = document.getElementById('root');
  if (container === null) throw new Error('#root elementi topilmadi');

  createRoot(container).render(
    <StrictMode>
      <Providers />
    </StrictMode>,
  );
};

void bootstrap();
